import { observable, reaction, runInAction } from 'mobx'
import axios from 'axios'
import {
  COUNTRY_TO_CURRENCY,
  CURRENCY_USDC,
  EXCHANGE_RATES_FALLBACK_URL,
  EXCHANGE_RATES_URL,
} from '@/constants/exchange.js'
import { makePersistable } from 'mobx-persist-store'
import { isSameDay } from 'date-fns'

export default class ExchangeStore {
  rootStore = null

  #reactions = []

  @observable accessor lastUpdate = ''
  @observable accessor rates = {}

  constructor(rootStore) {
    this.rootStore = rootStore
    this.rootStore.registerAfterConstructor(this.#_afterConstructor)
    this.rootStore.registerDeconstructor(this.#_deconstructor)
  }

  #_afterConstructor = async () => {
    await makePersistable(this, {
      name: 'exchange',
      properties: ['lastUpdate', 'rates'],
    })

    this.#reactions.push(reaction(() => this.time.currentDate, this.#updateRates))

    await this.#updateRates()
  }

  #_deconstructor = () => {
    this.#reactions.forEach(x => x())
    this.#reactions = []
  }

  get time() {
    return this.rootStore.timeStore
  }

  getCurrencyOfCountry = countryCode => COUNTRY_TO_CURRENCY[countryCode] ?? ''

  getEquivalentAmount = (amount, newCurrency) => {
    if (newCurrency === CURRENCY_USDC || !(newCurrency in this.rates)) return amount

    return Math.ceil(amount * this.rates[newCurrency])
  }

  #updateRates = async () => {
    if (isSameDay(this.lastUpdate, Date.now())) return

    const response = await axios
      .get(EXCHANGE_RATES_URL)
      .catch(() => axios.get(EXCHANGE_RATES_FALLBACK_URL))
      .catch(e => {
        console.error('[ExchangeRates] Error fetching exchange rates', e)
      })

    if (!response) return

    runInAction(() => {
      this.lastUpdate = response.data.date ?? ''
      this.rates = response.data[CURRENCY_USDC] ?? {}
    })
  }
}
